import {AbstractControl} from '@angular/forms';

export class NationalCodeValidatorService {
  nationalCodeValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (!/^[0-9]*$/.test(control.value)) {
      return {'nationalCode': true};
    }
    if (control.value.length < 10)
      return null;
    if (!/^\d{10}$/.test(control.value)
      || control.value === '0000000000'
      || control.value === '1111111111'
      || control.value === '2222222222'
      || control.value === '3333333333'
      || control.value === '4444444444'
      || control.value === '5555555555'
      || control.value === '6666666666'
      || control.value === '7777777777'
      || control.value === '8888888888'
      || control.value === '9999999999')
      return {'nationalCode': true};
    const check = parseInt(control.value[9]);
    let sum = 0;
    let i;
    for (i = 0; i < 9; ++i) {
      sum += parseInt(control.value[i]) * (10 - i);
    }
    sum %= 11;
    if (!((sum < 2 && check === sum) || (sum >= 2 && check + sum === 11)))
      return {'nationalCode': true};
    else
      return null;
  }

}
